import clsx from 'clsx';

import styles from './ContainedIcon.module.scss';

interface ContainedIconProps {
  className?: string;
  src: string;
  alt: string;
}

export const ContainedIcon = ({ className, src, alt }: ContainedIconProps) => {
  return (
    <div className={clsx(styles.containedIcon, className)}>
      <img src={src} alt={alt} />
    </div>
  );
};
